<div class="modal-header">
    <h4 class="modal-title">{{data?.name}}</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0" ngbAutofocus>
      <img class="img-fluid rounded mb-3 image-preview" [src]="data?.image" />
    </div>